module.exports = __webpack_public_path__ + "8b4f872c5de19974857328d06d3fe48f.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Semibold.woff2
// module id = 1011
// module chunks = 0